import React from "react";
import Layout from "../layout/layout";

const InformationPage = () => {
    const renewalData = [
        { name: "App Store", date: "April 18, 2026", link: "https://developer.apple.com/account", note: "Use 'apple developer' app from app store on a iphone or ipad to pay. And this can only be renewed from Kuwait" },
        { name: "Play Store", date: "-", link: "https://play.google.com/console", note: "It's an one time payment, no need to renew." },
        { name: "Digital Ocean", date: "Per month", link: "https://cloud.digitalocean.com/projects/6159786c-5ac0-44ad-85c0-315155e28892/resources?i=7d3dae", note: "It is a monthly susbscription. per month around 36-37$" },
        { name: "Domain", date: "December 26, 2025 ", link: "https://account.squarespace.com/domains/managed/scale-kuwait.com", note: "$12, auto renew on. It should be on December 1, 2025" },
    ];

    const body = (
        <div>
            <h1>Renewal Dates</h1>
            <ul>
                {renewalData.map((item, index) => (
                    <li key={index}>
                        <strong>{item.name}:</strong> {item.date} - <a href={item.link} target="_blank" rel="noopener noreferrer">Renew Here</a>
                        <p><em>Note:</em> {item.note}</p>
                    </li>
                ))}
            </ul>
        </div>
    );

    return <Layout body={body} title="Information" />;
};

export default InformationPage;